export const REF_NAME = 'CURRENCY';
export const REF_PATH = 'currency';
